<template>
  <div>
    <v-list-tile>
      <v-list-tile-content>
        Payment Informations:
      </v-list-tile-content>
      <v-list-tile-content
        v-if="!paymentInformation || !paymentInformation.accounts"
        class="align-end"
      >
        -
      </v-list-tile-content>
    </v-list-tile>
    <div
      v-if="paymentInformation && paymentInformation.accounts"
    >
      <div
        v-for="(account, index) in paymentInformation.accounts"
        :key="'account_' + index"
      >
        <div
          v-if="account.type === 'ddaccount'"
        >
          <v-list-tile>
            <v-list-tile-content
              class="pl-5"
            >
              DD Account
            </v-list-tile-content>
            <v-list-tile-content
              class="align-end"
            >
              IBAN: {{ account.details.mangoPay.walletDetails.iban }}
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content
              class="align-end"
            >
              BIC: {{ account.details.mangoPay.walletDetails.bic }}
            </v-list-tile-content>
          </v-list-tile>
        </div>
        <div
          v-if="account.type === 'mangopay'"
        >
          <v-list-tile>
            <v-list-tile-content
              class="pl-5"
            >
              Mangopay
            </v-list-tile-content>
            <v-list-tile-content
              class="align-end"
            >
              IBAN: {{ account.details.IBAN }}
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content
              class="align-end"
            >
              BIC: {{ account.details.BIC }}
            </v-list-tile-content>
          </v-list-tile>
        </div>
        <div
          v-else-if="account.type === 'secupay'"
        >
          <v-list-tile>
            <v-list-tile-content
              class="pl-5"
            >
              Secupay
            </v-list-tile-content>
            <v-list-tile-content
              class="align-end"
            >
              Trans ID: {{ account.details.secupay_trans_id }}
            </v-list-tile-content>
          </v-list-tile>
        </div>
        <div
          v-if="account.type === 'banktransfer'"
        >
          <v-list-tile>
            <v-list-tile-content
              class="pl-5"
            >
              Banktransfer
            </v-list-tile-content>
            <v-list-tile-content
              class="align-end"
            >
              IBAN: {{ account.details.IBAN }}
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content
              class="align-end"
            >
              BIC: {{ account.details.BIC }}
            </v-list-tile-content>
          </v-list-tile>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PaymentInformation',
  props: {
    paymentInformation: {
      type: Object,
      default: () => {},
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/shared/PaymentInformation.vue